export class MenuItem {
    constructor (public bebschreibung: string,
                 public image: string,
                 public href: string,
                 public newsitems: number,
                 public newsitems_red: number) {
    }
}
